<template>
    <div class="list list__articles">
        <h2 v-if="heading" class="list__heading">{{ heading }}</h2>

        <div class="list__article" v-for="(article, index) in articles" v-bind:key="index">
            <div class="list__article__image">
                <router-link :to="article.uri">
                    <img :src="article.image.url" :title="article.title" />
                </router-link>
            </div>
            <div class="list__article__text">
                <h2 class="list__article__heading">
                    <a :href="article.uri">{{ article.title }}</a>
                </h2>
                <p class="list__article__lead">
                    {{ article.lead }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListArticles',
    props: {
        heading: {
            type: String,
        },
        articles: {
            type: Array,
            required: true,
        },
    },
};
</script>
